import { DialogActions } from '@material-ui/core';

import { bind } from 'bind-decorator';

import { Button, FlatButton } from 'bz-core-controls';

import type { IBaseProps } from 'bz-core-controls/modal-new/confirmation';
import React from 'react';

export interface IProps extends Pick<IBaseProps, 'actionProps'> {
  className: string;

  onYes: () => void;
  onNo: () => void;
  onCancel: () => void;
}

class SaveCheckActions extends React.Component<IProps> {
  render() {
    const { actionProps, className } = this.props;

    return (
      <DialogActions {...actionProps} className={`${className} actions`}>
        <FlatButton
          className={`${className} btn-yes`}
          label="Cancel"
          secondary={false}
          onClick={this.onCancel}
          key="cancel"
        />
        <FlatButton
          className={`${className} btn-no`}
          label="No"
          secondary={true}
          onClick={this.onNo}
        />
        <Button
          className={`${className} btn-cancel`}
          label="Yes"
          primary={true}
          onClick={this.onYes}
        />
      </DialogActions>
    );
  }

  @bind
  private onYes(e: React.MouseEvent<any>): void {
    this.props.onYes();
  }

  @bind
  private onNo(e: React.MouseEvent<any>): void {
    this.props.onNo();
  }

  @bind
  private onCancel(e: React.MouseEvent<any>): void {
    this.props.onCancel();
  }
}

export default SaveCheckActions;
